import { memo } from "react";

const AlertNameDetails = ({ alertData }) => {
    if ((alertData?.expiryDate && alertData?.nStrikePrice1 &&
        alertData?.instrument)) {
        return (<div className='font-regular font-size1 color-subtext'>{`${alertData?.expiryDate?.slice(0, 2)}  ${alertData?.expiryDate?.slice(2, 5)} ${alertData?.nStrikePrice1} ${alertData?.optionType} `}</div>);
    } else if (!alertData?.expiryDate && !alertData?.nStrikePrice1 &&
        !alertData?.optionType) {
        return (<div className='d-flex align-items-center'><div className='font-regular font-size4 color-subtext'>{alertData?.series}</div></div>);
    }
    else if (alertData?.expiryDate && !alertData?.nStrikePrice1) {
        return (
            <div className='font-regular font-size1 color-subtext'>{`${alertData?.expiryDate.slice(0, 2)}  ${alertData?.expiryDate.slice(2, 5)} ${alertData?.instrument?.slice(0, 3)} `}</div>
        );
    } else {
        return null;
    }
};
export default memo(AlertNameDetails);